import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  
  border-radius: 8px;
  min-height: 400px;

`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;

  > span {
    font-size: 1.5rem;
    width: 100%;
    flex:1;
    padding-right: 1rem;
  }
`;

export const AddButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 13.75rem;
  height: 3.125rem;
  cursor: pointer;
  border: 1px solid var(--primary);
  border-radius: 0.37rem;
  background-color: #FFF;
  transition:all 0.6s ease;
  padding: 0 0.5rem;

  span {
    font-size: 1.12rem;
    text-align: center;
  }
  svg {
    color: var(--btn-finish);
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }

`;

export const ContainerAddress = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
  margin-top:1rem;
`;